import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionCta } from './SectionCta';
const SITUATIONS = ['Dudó si un paciente realmente cumplía criterios para iniciar una TRT.', 'Perdió tiempo revisando múltiples artículos antes de tomar una decisión.', 'Sintió inseguridad al interpretar SHBG, testosterona libre, LH, FSH o prolactina.', 'No estaba completamente seguro de cómo monitorizar al paciente después de iniciar.', 'Temió cometer un error por falta de una guía clara.', 'Quiso un protocolo práctico en lugar de estudiar cientos de páginas.'];
export function ForYou() {
  return <section className="w-full bg-cream-50 py-12 sm:py-16" aria-labelledby="for-you-title" data-id="element-84" data-mp="3j4auwyo45nf">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-85" data-mp="3vnopja70bfp3">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-86" data-mp="3vm3uljgs5uqp">
          Antes de continuar
        </p>
        <h2 id="for-you-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-87" data-mp="21ap4h1juxtaf">
          ¿Este sistema fue creado para usted?
        </h2>
        <p className="mt-3 text-center text-[15px] text-navy-800/75 sm:text-base" data-id="element-88" data-mp="397lclsfxvtyt">
          Sí, si alguna vez…
        </p>

        <ul className="mt-6 space-y-3" data-id="element-89" data-mp="3e420qmn528bw">
          {SITUATIONS.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-navy-900/10 bg-white p-3.5 shadow-[0_8px_20px_-16px_rgba(11,32,56,0.5)]" data-id="element-90" data-mp="3iyg2r7wb3dpj">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-91" data-mp="3rvqbomlniqra" />
              <span className="text-[14px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-92" data-mp="5qv333l5eysd">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-6 rounded-2xl bg-navy-900 p-4 text-center text-[14px] font-semibold leading-snug text-cream-50 sm:text-base" data-id="element-93" data-mp="27hooi7htia8a">
          Si respondió “sí” a una sola de estas situaciones… este sistema fue diseñado para
          usted.
        </p>

        <SectionCta label="Quiero dejar de dudar en cada caso" data-id="element-94" data-mp="1vgzu1jhcgynp" />
      </div>
    </section>;
}